import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ConsultationsPayload,
  ActionType,
  IConsultationListResponse,
} from "models/consultations/consultationList";
import { httpStatus } from "configs/httpStatus";
import { getConsultations } from "services/consultations";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./consultationListActions";

function* consultationListSaga({ payload }: { payload: ConsultationsPayload }) {
  try {
    const response: IConsultationListResponse = yield call(
      getConsultations,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetConsultationListWatcher() {
  yield takeLatest(
    ActionType.GET_CONSULTATION_LIST as any,
    consultationListSaga
  );
}

export default [fork(onGetConsultationListWatcher)];
